<template>
  <div>
    <PageTitle :title="title"></PageTitle>
    <div style="margin-top: 160px;">
      <carousel-3d :controls-visible="true" :display="5" :controls-width="30" :controls-height="60" :clickable="false">
      <slide :index="0">
        <img src="../assets/img/shot/thumb/35express.jpg">
      </slide>
      <slide :index="1">
        <img src="../assets/img/shot/thumb/accentskinhealth.jpg">
      </slide>
      <slide :index="2">
        <img src="../assets/img/shot/thumb/adrenaclick.jpg">
      </slide>
      <slide :index="3">
        <img src="../assets/img/shot/thumb/alueur-candles.jpg">
      </slide>
      <slide :index="4">
        <img src="../assets/img/shot/thumb/anprometei.jpg">
      </slide>
      <slide :index="5">
        <img src="../assets/img/shot/thumb/aquapharm.jpg">
      </slide>
      <slide :index="6">
        <img src="../assets/img/shot/thumb/bluelizard.jpg">
      </slide>
      <slide :index="7">
        <img src="../assets/img/shot/thumb/burnspictureframe.jpg">
      </slide>
      <slide :index="8">
        <img src="../assets/img/shot/thumb/dbaresults.jpg">
      </slide>
      <slide :index="9">
        <img src="../assets/img/shot/thumb/doubleeagledevelopment.jpg">
      </slide>
      <slide :index="10">
        <img src="../assets/img/shot/thumb/drawtex.jpg">
      </slide>
      <slide :index="11">
        <img src="../assets/img/shot/thumb/epinephrineautoinject.jpg">
      </slide>
      <slide :index="12">
        <img src="../assets/img/shot/thumb/gcghealthcare.jpg">
      </slide>
      <slide :index="13">
        <img src="../assets/img/shot/thumb/gcgmarketing.jpg">
      </slide>
      <slide :index="14">
        <img src="../assets/img/shot/thumb/geografia-nsk.jpg">
      </slide>
      <slide :index="15">
        <img src="../assets/img/shot/thumb/gwynngroup.jpg">
      </slide>
      <slide :index="16">
        <img src="../assets/img/shot/thumb/lodgecreekwhitetails.jpg">
      </slide>
      <slide :index="17">
        <img src="../assets/img/shot/thumb/lt-academy.jpg">
      </slide>
      <slide :index="18">
        <img src="../assets/img/shot/thumb/mcdls.jpg">
      </slide>
      <slide :index="19">
        <img src="../assets/img/shot/thumb/mineral-shine.jpg">
      </slide>
      <slide :index="20">
        <img src="../assets/img/shot/thumb/my-firstcall.jpg">
      </slide>
      <slide :index="21">
        <img src="../assets/img/shot/thumb/protos.jpg">
      </slide>
      <slide :index="22">
        <img src="../assets/img/shot/thumb/xpansiongrafting.jpg">
      </slide>
    </carousel-3d>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue'
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
  name: 'Portfolio',
  data() {
    return {
    }
  },
  computed: {

  },
  props: {
    lang: String,
    title: String
  },
  components: {
    PageTitle,
    Carousel3d,
    Slide
  }
}
</script>
<style scoped>
</style>